export const formatRows = (listaItems ) =>
   
  listaItems.map((item) => {
    let cod= item["articulos"]?.art_codigo;
    let desc= item["articulos"]?.art_descripcion;
    let idart= item.ajud_art_id;
    return {
      id: item.ajd_id,
      ajud_art_id: idart,
      art_codigo: cod,
      art_descripcion: desc,
      ajud_stockactual: item.ajud_stockactual,
      ajud_stockreelevado: item.ajud_stockreelevado, 
      ajud_obs: item.ajud_obs,
    };
  });
   